import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Page } from 'src/app/page';
import { CustomPaginationService } from 'src/services/custom-pagination.service';
import { ServiceProviderSubjectService } from 'src/services/service-provider-subject.service';
import { ModalEventEnum, ModalSizeEnum } from 'src/types';
import { ServiceProviderSubjectNewRecordComponent } from '../service-provider-subject-new-record/service-provider-subject-new-record.component';
import { MatDialog } from '@angular/material/dialog';
import { LocalStorageService } from 'src/app/local-storage.service';
import { TranslateService } from '@ngx-translate/core';
import { WarningMessageComponent } from 'src/app/warning-message/warning-message.component';
import { UserService } from 'src/services/user.service';
import { ToastrImplService } from 'src/services/toastr.service';

@Component({
  selector: 'service-provider-subject-record',
  templateUrl: './service-provider-subject-record.component.html',
  styleUrls: ['./service-provider-subject-record.component.scss']
})
export class ServiceProviderSubjectRecordComponent implements OnInit {
  @Input() subject: any;
  page: Page<any> = new Page();
  subjectId: string;
  displayedColumns: string[] = ['providedService', 'rightGrantedDate', 'outcomeStatus', 'realizationStartDate', 'realizationEndDate', 'rightEndDate', 'monthlyPrice', 'paymentMethod', 'actions'];
  loggedIn: any;
  serviceProviderId;
  isAssociate = false;
  roleLength: any;
  object: any = {
    document: '',
    action: '',
    subjectId: '',
    message: '',
    title: ''
  };

  constructor(
    public router: Router,
    private paginationService: CustomPaginationService,
    private route: ActivatedRoute,
    private serviceProviderSubjectService: ServiceProviderSubjectService,
    private dialog: MatDialog,
    private localStorageService: LocalStorageService,
    private translate: TranslateService,
    private userService: UserService,
    private toastr: ToastrImplService
  ) { 
    this.loggedIn = JSON.parse(this.localStorageService.get('loggedUser'));
    this.serviceProviderId = this.loggedIn?.serviceProviderId;
    this.route.params.subscribe(params => {
      this.subjectId = params.id;
    });
    this.roleLength = JSON.parse(this.localStorageService.get('loggedUser')).role.length;
    this.isAssociate = this.roleLength === 1 ? this.userService.isAssociate() : this.localStorageService.get('primaryRole') === ' Сарадник';
  }

  ngOnInit(): void {
    this.doFilter();
  }

  doFilter() {
    this.serviceProviderSubjectService.getServiceProviderSubjectRecords(this.page.pageable, this.subjectId, this.serviceProviderId).subscribe((page: any) => {
      this.page = page;
      this.page.pageable.pagePerShow = page.number + 1;
    });
  }

  getNextPage() {
    this.page.pageable = this.paginationService.getNextPage(this.page);
    this.doFilter();
  }

  getPreviousPage() {
    this.page.pageable = this.paginationService.getPreviousPage(this.page);
    this.doFilter();
  }

  getFirstPage(): void {
    this.page.pageable = this.paginationService.getFirstPage(this.page);
    this.doFilter();
  }

  getLastPage(): void {
    this.page.pageable = this.paginationService.getLastPage(this.page);
    this.doFilter();
  }

  getPageInNewSize(pageSize: number) {
    this.page.pageable = this.paginationService.getPageInNewSize(this.page, pageSize);
    this.doFilter();
  }

  addNewRecord() {
    const dialogRef = this.dialog.open(ServiceProviderSubjectNewRecordComponent, {
      panelClass: 'overlay-panel',
      disableClose: true,
      width: ModalSizeEnum.DEFAULT,
      data: {
        subjectId: this.subjectId,
        serviceProviderId: this.serviceProviderId,
        record: null
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        return;
      }

      const payload = {
        serviceProviderSubjectId: this.subjectId,
        providedServiceId: result.providedService.id,
        rightGrantedDate: result.rightGrantedDate,
        realizationStartDate: result.realizationStartDate,
        realizationEndDate: result.realizationEndDate,
        rightEndDate: result.rightEndDate,
        outcomeStatus: result.outcomeStatus,
        monthlyPrice: result.monthlyPrice,
        paymentMethodId: result.paymentMethod?.id ?? null
      };

      this.serviceProviderSubjectService.addServiceProviderSubjectRecord(payload).subscribe({
        next: () => this.doFilter(),
        error: err => {
          console.error('Failed to add record', err);
          if (err.status === 400) {
            this.toastr.error('SERVICE_PROVIDERS.SUBJECT_RECORD.PASSIVE_ERROR');
          }
        }
      });
    });
  }  

  handleDeleteDialog(element: any) {
    this.translate.get('WARNING_DIALOG.SERVICE_PROVIDER_SUBJECT_RECORD_DELETE.MESSAGE').subscribe((res: string) => {
        this.object.message = res;
    });
    this.translate.get('WARNING_DIALOG.SERVICE_PROVIDER_SUBJECT_RECORD_DELETE.TITLE').subscribe((res: string) => {
        this.object.title = res;
    });
    this.object.action = ModalEventEnum.DELETE;
    const dialogRef = this.dialog.open(WarningMessageComponent, {
      panelClass: 'overlay-panel',
      disableClose: true,
      width: ModalSizeEnum.MINI,
      data: this.object,
    });

    dialogRef.afterClosed().subscribe(result => {
        const { event, data } = result;
        if (event === ModalEventEnum.DELETE && data.status) {
          this.serviceProviderSubjectService.deleteServiceProviderSubjectRecord(element.id).subscribe(res => {
            this.doFilter();
          });
        }
    });
  }

  handleEditDialog(element: any) {
    const dialogRef = this.dialog.open(ServiceProviderSubjectNewRecordComponent, {
      panelClass: 'overlay-panel',
      disableClose: true,
      width: ModalSizeEnum.DEFAULT,
      data: {
        subjectId: this.subjectId,
        serviceProviderId: this.serviceProviderId,
        record: element,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        return;
      }

      const payload = {
        id: result.id,
        serviceProviderSubjectId: this.subjectId,
        providedServiceId: result.providedService.id,
        rightGrantedDate: result.rightGrantedDate,
        realizationStartDate: result.realizationStartDate,
        realizationEndDate: result.realizationEndDate,
        rightEndDate: result.rightEndDate,
        outcomeStatus: result.outcomeStatus,
        monthlyPrice: result.monthlyPrice,
        paymentMethodId: result.paymentMethod?.id ?? null
      };

      this.serviceProviderSubjectService.addServiceProviderSubjectRecord(payload).subscribe({
        next: () => this.doFilter(),
        error: err => console.error('Failed to add record', err)
      });
    });
  }

}
